import React, { useEffect, useState } from 'react';

import { Route, Routes, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { get } from 'lodash';

import { routesConstants } from '@/constants';
import { Loader } from '@/component';
import {
  BankInfo,
  ContactUs,
  Dashboard,
  Financial,
  MyMusic,
  PersonalInfo,
  Profile,
  Register,
  Reports,
  UploadMusic,
  Login,
  TermsAndCondition,
  EmailVerify,
  ResetPassword,
  ForgotPassword,
} from '@/pages';

import { songActions, userActions } from '@/actions';
import { musicPlayerStore, songsStore, useArtistStore, withdrawStore } from '@/store';

import './App.css';

const App = () => {
  const navigate = useNavigate();

  const { setArtist, setAuthentication, authenticate, defaultArtist } = useArtistStore();
  const { setSongs } = songsStore();
  const { setWithdraw } = withdrawStore();
  const { setMusic } = musicPlayerStore();

  const [loading, setLoading] = useState(true);

  const ref = React.useRef(false);

  useEffect(() => {
    (async () => {
      if (ref.current) return;
      ref.current = true;

      const refreshTokenData = await userActions.refreshTokenAction();
      if (!refreshTokenData.success) {
        setLoading(false);
        return;
      }

      const artist_id = get(refreshTokenData, 'data.id', '');
      const data = await userActions.fetchArtistAction(artist_id);
      const code = get(data, 'data.code', '');

      if (code === 'PHONE_NOT_VERIFIED') {
        setAuthentication({
          isAuthenticated: true,
          isPhoneVerified: false,
        });
        setArtist({
          ...defaultArtist,
          id: artist_id,
        });
        navigate(routesConstants.ROUTES.PERSONAL_INFO);
      } else if (code === 'OK') {
        const songsData = await songActions.fetchSongsAction(get(data, 'data.data.id', {}));

        if (songsData.success) {
          setSongs(get(songsData, 'data', []));
          setMusic(get(songsData, 'data[0]', {}));
        }

        const WithdrawalData = await userActions.fetchWithdrawalAction(
          get(data, 'data.data.id', {}),
        );
        if (WithdrawalData.success) {
          setWithdraw(get(WithdrawalData, 'data', {}));
        }

        setAuthentication({
          isAuthenticated: true,
          isPhoneVerified: true,
        });

        setArtist(get(data, 'data.data', {}));
      }
      setLoading(false);
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);

  if (loading) {
    return <Loader isLoading={loading} />;
  }

  return (
    <div>
      {authenticate.isPhoneVerified ? (
        <Routes>
          <Route path={routesConstants.ROUTES.HOME} element={<Dashboard />} />
          <Route path={routesConstants.ROUTES.MY_MUSIC} element={<MyMusic />} />
          <Route path={routesConstants.ROUTES.UPLOAD_MUSIC} element={<UploadMusic />} />
          <Route path={routesConstants.ROUTES.REPORTS} element={<Reports />} />
          <Route path={routesConstants.ROUTES.FINANCIAL} element={<Financial />} />
          <Route path={routesConstants.ROUTES.TnC} element={<TermsAndCondition />} />
          <Route path={routesConstants.ROUTES.PROFILE} element={<Profile />} />
          <Route path={routesConstants.ROUTES.CONTACT_US} element={<ContactUs />} />
          <Route path="*" element={<Dashboard />} />
        </Routes>
      ) : authenticate.isAuthenticated ? (
        <Routes>
          <Route path={routesConstants.ROUTES.PERSONAL_INFO} element={<PersonalInfo />} />
          <Route path={routesConstants.ROUTES.BANK_INFORMATION} element={<BankInfo />} />
          <Route path="*" element={<PersonalInfo />} />
        </Routes>
      ) : (
        <Routes>
          <Route path={routesConstants.ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={routesConstants.ROUTES.LOGIN} element={<Login />} />
          <Route path={routesConstants.ROUTES.REGISTER} element={<Register />} />
          <Route path={routesConstants.ROUTES.EMAIL_VERIFIED} element={<EmailVerify />} />
          <Route path={routesConstants.ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
          {/* <Route path={routesConstants.ROUTES.TnC} element={<TermsAndCondition />} /> */}
          <Route path="*" element={<Login />} />
        </Routes>
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        draggable={false}
        closeOnClick
        pauseOnHover
        // progress = {undefined}
        theme={'light'}
        style={{ fontSize: '1.4rem' }}
      />
    </div>
  );
};

export default App;
